import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Shopify is a hosted commerce platform that lets brands sell quickly without managing infrastructure. We take it further with custom themes, tailored app functionality and clean integrations to your wider stack.",
    "From first launch to scaling a busy catalogue, we build Shopify stores that look right, load fast and are genuinely easy to run day to day.",
];

const FEATURES = [
    { title: "Custom theme development", text: "Storefronts coded to your brand, not a stock template everyone else uses." },
    { title: "App & feature customisation", text: "Bespoke functionality and private apps that extend Shopify to fit your business." },
    { title: "Payments & integrations", text: "Gateways, shipping, ERP and marketing tools connected and working together." },
    { title: "Migration to Shopify", text: "Move from another platform with your products, URLs and SEO intact." },
];

const CHECKS = [
    "Custom Shopify themes",
    "Private & custom apps",
    "Payment gateway integration",
    "Store migration",
    "Performance & conversion tuning",
];

export default function Shopify() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="E-Commerce" title="Shopify Development" eyebrowAs="span">
                    Conversion-focused Shopify stores — custom themes, apps and integrations that make selling online effortless.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
